import { RequestBodyHAOpsDashboard } from '@/pages/AccountingCenter/store/types';
import { AxiosInstance } from 'axios';

export default class HedgeAccountingOpsAPI {
  client: AxiosInstance;

  constructor(client: AxiosInstance) {
    this.client = client;
  }

  async fetchHAOpsDashboard(data: RequestBodyHAOpsDashboard) {
    return this.client.post('v2/hedge-accounting/ops-dashboard/', data);
  }
}
